// extracted by mini-css-extract-plugin
module.exports = {"borderBottom":"styles_borderBottom__tx1Qr","title":"styles_title__2ygvz","reset":"styles_reset__2QDH8","grayText":"styles_grayText__2btQ1"};